import '@mdi/font/css/materialdesignicons.css';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { createVuetify } from 'vuetify';
import { fr } from 'vuetify/locale';
import utilsConstants from '@/constants/utilsConstants.ts';

export const vuetify = createVuetify({
  locale: {
    locale: 'fr',
    fallback: 'fr',
    messages: {
      fr,
    },
  },
  components,
  directives,
  display: {
    thresholds: {
      lg: utilsConstants.MIN_WIDTH_WEB,
    },
    mobileBreakpoint: 'lg',
  },
  theme: {
    defaultTheme: 'executive',
    themes: {
      executive: {
        dark: false,
        colors: {
          primary: '#6ED2B1',
          'primary-darken-1': '#339b7c',
          'primary-darken-2': '#53806F',
          'primary-darken-3': '#386757',
          'primary-darken-4': '#234f3f',
          'primary-lighten-1': '#8aefcc',
          secondary: '#51806F',
          accent: '#538AAE',
          error: '#cc0000',
          info: '#53806F',
          success: '#6ED2B1',
          warning: '#E97949',
          'on-primary': '#FFFFFF',
          darkRed: '#6F181A',
          darkGray: '#757575',
          gray: '#C8C8C8',
          white: '#FFFFFF',
        },
      },
      hr: {
        dark: false,
        colors: {
          primary: '#907EEC',
          'primary-darken-1': '#584db3',
          'primary-darken-2': '#907EEC',
          'primary-darken-3': '#342d6a',
          'primary-darken-4': '#234f3f',
          'primary-lighten-1': '#ac98ff',
          secondary: '#4D4384',
          accent: '#A872D9',
          error: '#cc0000',
          info: '#53806F',
          success: '#6ED2B1',
          warning: '#E97949',
          darkRed: '#6F181A',
          darkGray: '#757575',
          gray: '#C8C8C8',
          white: '#FFFFFF',
        },
      },
      manager: {
        dark: false,
        colors: {
          primary: '#E97949',
          'primary-darken-1': '#ab4519',
          'primary-darken-2': '##E97949',
          'primary-darken-3': '#64341b',
          'primary-darken-4': '#234f3f',
          'primary-lighten-1': '#ff9462',
          secondary: '#7F4B31',
          accent: '#EE8185',
          error: '#cc0000',
          info: '#53806F',
          success: '#6ED2B1',
          warning: '#E97949',
          darkRed: '#6F181A',
          darkGray: '#757575',
          gray: '#C8C8C8',
          white: '#FFFFFF',
        },
      },
    },
  },
});
